import React from "react";
import { useEffect, useState } from "react";
import Header from "../Header";
import HeaderThrift from "../HeaderThrift";
import { getGlobalData, getLocale } from "../../api/cms";
import client from "../../Client";

interface HeaderItem {
  sys: { id: string };
  fields?: {
    thriftHeader?: boolean;
    aliasesToRenderHeader?: string[];
  };
}

interface HeaderResponse {
  total: number;
  items: HeaderItem[];
}

const HeaderWrapper: React.FC<any> = () => {
  const [headerEntryId, setHeaderEntryId] = useState("");
  const [thriftHeader, setThriftHeader] = useState(false);

  useEffect(() => {
    const fetchHeader = async () => {
      try {
        const globalData = getGlobalData();
        const currLocale = getLocale();

        const location = window.location.pathname;
        const pathArray = location.split("/").filter(Boolean);
        const aliasArray =
          pathArray[0]?.match(/[a-z]/) && pathArray[0].length < 3
            ? pathArray.slice(1)
            : pathArray;
        const currPathAlias = "/" + aliasArray.join("/");

        // Try exact match
        let response: HeaderResponse = await client.getEntries({
          content_type: "header",
          "fields.domains": globalData.domain,
          locale: currLocale,
          limit: 1,
          "fields.aliasesToRenderHeader": currPathAlias,
        });

        if (response.total > 0) {
          const item = response.items[0];
          setHeaderEntryId(item.sys.id);
          if (item.fields?.thriftHeader) setThriftHeader(true);
          return;
        }

        // Try parent paths with wildcard
        let pathParts = currPathAlias.split("/").filter(Boolean);
        let found = false;

        while (pathParts.length > 0 && !found) {
          pathParts.pop();
          const queryAlias = "/" + pathParts.join("/") + "/*";

          response = await client.getEntries({
            content_type: "header",
            "fields.domains": globalData.domain,
            locale: currLocale,
            limit: 1,
            "fields.aliasesToRenderHeader": queryAlias,
          });

          if (response.total > 0) {
            const item = response.items[0];
            setHeaderEntryId(item.sys.id);
            if (item.fields?.thriftHeader) setThriftHeader(true);
            found = true;
          }
        }

        // Fallback default header
        if (!found) {
          response = await client.getEntries({
            content_type: "header",
            "fields.domains": globalData.domain,
            "fields.thriftHeader[ne]": "yes",
            "fields.aliasesToRenderHeader[exists]": false,
            locale: currLocale,
            limit: 1,
          });

          if (response.total > 0) {
            setHeaderEntryId(response.items[0].sys.id);
          }
        }
      } catch (err) {
        console.error(err);
      }
    };

    fetchHeader();
  }, []); // Runs once on mount

  return thriftHeader ? (
    <HeaderThrift headerEntryId={headerEntryId} />
  ) : (
    <Header headerEntryId={headerEntryId} />
  );
};

export { HeaderWrapper };
